<!-- Copy is the client's own, word for word (ELIO-6393). -->
<div class="auto-save-offer">

  <div class="auto-save-offer__head">
    <span class="material-symbols-outlined auto-save-offer__icon">cloud_done</span>
    <h2 class="auto-save-offer__title">Save your cart automatically?</h2>
  </div>

  <p class="auto-save-offer__text">
    With auto-save on, everything you add to your cart is reserved right away &ndash; you never
    have to click the &quot;update order&quot; button again.
  </p>
  <p class="auto-save-offer__text">
    Your order remains editable until your cut-off day and time. You can turn auto-save off at
    any time in your profile.
  </p>

  <div class="auto-save-offer__actions">
    <button type="button" class="btn btn-outline-primary w-100" (click)="close(false)">
      Keep saving manually
    </button>
    <button type="button" class="btn btn-primary w-100" (click)="close(true)">
      Turn on auto-save
    </button>
  </div>

  <div class="auto-save-offer__opt-out">
    <mat-checkbox (change)="handleCheckboxChange($event.checked)">
      Don't show me this message again
    </mat-checkbox>
  </div>

</div>
